import Vue from 'vue'
import App from './App.vue'
import {
  BootstrapVue,
  BootstrapVueIcons
} from 'bootstrap-vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/style.css'

import VueGtag from "vue-gtag";

Vue.use(VueGtag, {
  config: {
    id: "UA-172446314-1",
    params: {
      send_page_view: false
    }
  }
}, router);

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

import router from './router'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
